/* eslint-disable no-underscore-dangle */
import React, { useMemo } from 'react';
import WestwingPop from './SignupOverlay/WestwingPop';
import useTranslate from 'Hooks/useTranslate';
import { useConfig } from 'AppShell/hooks';
import { replaceStringWithComponents } from 'Helpers/utils';

type TranslatedTextType = {
    props: { dangerouslySetInnerHTML?: { __html?: string } };
};

const S2cTermsContent: React.FunctionComponent<{
    westwingPopContainerRef: React.RefObject<HTMLDivElement>;
}> = ({ westwingPopContainerRef }) => {
    const { t } = useTranslate();
    const config = useConfig();
    const dataProtectionUrl = config.links.dataProtection;

    const content = useMemo(
        () =>
            replaceStringWithComponents(
                (
                    t(
                        'signupOverlay_I would like to regularly receive newsletters about sales and special promotions from %s. These settings can be %s anytime'
                    ) as TranslatedTextType
                ).props?.dangerouslySetInnerHTML?.__html || '',
                [
                    <WestwingPop key="westwing_popup" forRegistration containerRef={westwingPopContainerRef} />,
                    <a
                        key="s2c_overlay_revoked_link"
                        href={`${dataProtectionUrl}#opt_out_option`}
                        target="_blank"
                        className="qa-login-signup-form__privacy-revoked-link"
                        rel="noreferrer"
                    >
                        {(t('signupOverlay_revoked') as TranslatedTextType).props?.dangerouslySetInnerHTML?.__html ||
                            ''}
                    </a>,
                ]
            ),
        [dataProtectionUrl, westwingPopContainerRef, t]
    );

    return <>{content}</>;
};

export default S2cTermsContent;
